import React, { useState, useEffect } from "react";

import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
import "./selectArticles.css";

const Article = (props) => {
  useEffect(() => {}, []);

  return (
    <>
      {props.cat.default && props.cat.label != "Amar's Content" && props.cat.label != "testuser's Content"?
      <div
        className="Cimg"
        onClick={() => {
          props.handleSelect(props.ind);
        }}
      >
        {props.cat.kwImageUrl ? (
          
          <img style={{ minHeight: '250px'}} src={props.cat.kwImageUrl} />
        ) : (
              <img style={{ minHeight: '250px' }} src={require("../../components/Vestorly/assets/default.png")} />
        )} 

        <h4 className="CTitle">{props.cat.label}</h4>
      </div>:''}
    </>
  );
};

export default Article;
